import React, { useContext, useState, useEffect } from 'react';
import { ContextoFinanceiro } from '../../services/financeiro';
import Contratos from './Contratos';
import Menu from './Menu';
import ParcelasPagas from './ParcelasPagas';
import ParcelasAPagar from './ParcelasAPagar';
import GerarBoleto from './GerarBoleto';
import ResumoBoletos from './ResumoBoletos';
import HeaderStroke from '../HeaderStroke';
import GerarExtrato from './GerarExtrato';
import Renegociacao from './Renegociacao';
import GerarIrrf from './GerarIrrf';
import ErrorMsg from './ErrorMsg';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

import ModalGerarPix from './ModalGerarPix';

import InfoMessage from './InfoMessage';
import ValidIfIsWithinOperatingPaymentPeriod from '../../Utils/ValidIfIsWithinOperatingPaymentPeriod';

const Financeiro = ({ idVenda, redirectRenegociar }) => {
  const { tema } = useContext(ContextoListaApartamentos);
  const {
    showModalGerarPix,
    setShowModalGerarPix,
    getParcelasPagas,
    getParcelasAPagar,
    validaAssinaturaDocuSign,
    dadosDocSign,
  } = useContext(ContextoFinanceiro);

  // dependendo do contrato serão exibidos as parcelas
  const [contratoSelecionado, setContrato] = useState([]);

  const [showParcelasPagar, setshowParcelasPagar] = useState(true);

  const [showParcelasPagas, setshowParcelasPagas] = useState(false);

  const [showRenegociacao, setShowRenegociacao] = useState(false);

  const [gerarExtrato, setGerarExtrato] = useState(false);

  const [gerarIrrf, setGerarIrrf] = useState(false);

  const [gerarBoleto, setGerarBoleto] = useState(false);

  const [parcelasSelecionadas, setParcelasSelecionadas] = useState([]);

  const [parcelasSelecionadasOriginal, setParcelasSelecionadasOriginal] =
    useState([]);

  const [loading, setLoading] = useState(true);

  const [loadingParcelasAPagar, setLoadingParcelasAPagar] = useState(true);

  const [dadosDesconto, setDadosDesconto] = useState('');

  const [parcelasAPagarComBoleto, setParcelasAPagarComBoleto] = useState([]);

  const [dataParaAgendar, setDataParaAgendar] = useState('');

  const [parcelasAPagar, setParcelasAPagar] = useState([]);

  const [codOcorrencia, setCodOcorrencia] = useState('');

  const [solicitacaoInvalida, setSolicitacaoInvalida] = useState(false);

  const [stateGetParcelasPagas, setStateGetParcelasPagas] = useState([]);

  const [erroConsultarDescontoParcela, setErroConsultarDescontoParcela] =
    useState(false);

  const [valoresAntecipacaoParcelas, setValoresAntecipacaoParcelas] = useState(
    {}
  );

  // inicia como true, desabilita o botão (somente desabilita se todas parcelas pagas tiverem o exibirIrrf false)
  const [disableBtnIrrf, setDisableBtnIrrf] = useState('');

  const isWithinOperatingPaymentPeriod =
    ValidIfIsWithinOperatingPaymentPeriod();

  let codCobranca = '';
  if (contratoSelecionado != undefined)
    codCobranca = contratoSelecionado.codCobranca;

  async function getParcelas() {
    setStateGetParcelasPagas([]);
    let idsVenda = {
      IdVenda:
        contratoSelecionado?.idVenda || contratoSelecionado?.contrato?.idVenda,
      IdVendaCarteira:
        contratoSelecionado?.idVendaCarteira ||
        contratoSelecionado?.contrato?.idVendaCarteira,
    };

    let resultGetParcelas = [];
    if (idsVenda.IdVenda)
      try {
        resultGetParcelas = await getParcelasPagas(idsVenda);

        setStateGetParcelasPagas(resultGetParcelas.data);

        return resultGetParcelas.data;
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
  }

  useEffect(() => {
    setGerarExtrato(false);
    setGerarIrrf(false);

    if (!showRenegociacao) {
      if (showParcelasPagas) setshowParcelasPagas(true);
      else setshowParcelasPagar(true);
      if (redirectRenegociar && contratoSelecionado?.idVenda === idVenda) {
        setShowRenegociacao(true);
        setshowParcelasPagar(false);
        setshowParcelasPagas(false);
      }
    } else {
      setShowRenegociacao(false);
      setshowParcelasPagar(true);
    }

    checkExibirIrrf();
  }, [contratoSelecionado]);

  async function checkExibirIrrf() {
    setDisableBtnIrrf(true);

    if (contratoSelecionado != undefined) {
      let tempPagas = [];

      try {
        tempPagas = await getParcelas();

        if (tempPagas != undefined && tempPagas?.recebidas?.length > 0)
          for (let a of tempPagas.recebidas) {
            if (a.exibirGeraIrrf) {
              setDisableBtnIrrf(false);
            }
          }
      } catch (error) {
        setDisableBtnIrrf(true);
      }
    }
  }

  async function consultaDescontoAntecipacao(data, parcelas) {
    setLoading(true);

    setGerarBoleto(true);

    let tempResult = [];

    let totalDesconto = 0;

    let totalPercentualDesconto = 0;

    let totalBoleto = 0;

    let totalValorReajustadoNaoAntecipado = 0;

    for (let itemParcela of parcelas) {
      const valorReajustadoParcela =
        itemParcela?.valorReaj ?? itemParcela?.parcela?.valorReajustado;

      const valorReajustadoNaoAntecipado =
        itemParcela?.valorReajustadoNaoAntecipado ??
        itemParcela?.parcela?.valorReajustadoNaoAntecipado;

      totalBoleto += valorReajustadoParcela;
      totalValorReajustadoNaoAntecipado += valorReajustadoNaoAntecipado;

      tempResult.push(itemParcela);
    }

    setDadosDesconto({
      totalDesconto,
      totalPercentualDesconto,
      totalBoleto,
      totalValorReajustadoNaoAntecipado,
    });

    setParcelasSelecionadas(tempResult);

    setLoading(false);
  }

  function formataData(data) {
    if (data == undefined) return dataParaAgendar;

    if (data.split('T').length > 1) return data;

    let resultSplitData = data.split('-');

    let dateSet = new Date();

    dateSet.setFullYear(resultSplitData[0]);

    dateSet.setMonth(parseInt(resultSplitData[1]) - 1);

    dateSet.setDate(resultSplitData[2]);

    return (
      dateSet.getFullYear() +
      '-' +
      (dateSet.getMonth() + 1) +
      '-' +
      dateSet.getDate() +
      'T00:00:00'
    );
  }

  const disableMenuBtn = () => {
    if (
      parcelasAPagar?.length == 0 &&
      stateGetParcelasPagas?.recebidas != undefined &&
      stateGetParcelasPagas?.recebidas?.length == 0
    )
      return true;
    else return false;
  };

  if (!showParcelasPagas) {
    let resumo = document.getElementById('divResumoParcelasSelecionadas');
    if (resumo) {
      resumo.style.display = 'none';
    }
  }

  async function parcelasAPagarFunction() {
    setParcelasSelecionadas([]);
    setLoadingParcelasAPagar(true);

    let idsVenda = {
      IdVenda:
        contratoSelecionado?.idVenda || contratoSelecionado?.contrato?.idVenda,
      IdVendaCarteira:
        contratoSelecionado?.idVendaCarteira ||
        contratoSelecionado?.contrato?.idVendaCarteira,
    };

    let resultGetParcelas = [];
    if (idsVenda.IdVenda)
      try {
        const { habilitarFinanceiro } = await validaAssinaturaDocuSign(
          idsVenda.IdVenda,
          idsVenda.IdVendaCarteira
        );

        if (habilitarFinanceiro) {
          resultGetParcelas = await getParcelasAPagar(idsVenda);
        }

        const {
          parcelas: parcelasAPagar = [],
          valorAntecipadoUltimaParcela,
          valorRealUltimaParcela,
          valorTotalAntecipado,
          valorTotalReal,
        } = resultGetParcelas.data;

        setValoresAntecipacaoParcelas({
          valorAntecipadoUltimaParcela,
          valorRealUltimaParcela,
          valorTotalAntecipado,
          valorTotalReal,
        });

        await getParcelas();

        setParcelasAPagar(parcelasAPagar);

        setParcelasAPagarComBoleto(parcelasAPagar);

        setLoadingParcelasAPagar(false);
      } catch (error) {
        setParcelasAPagar([]);
        setParcelasAPagarComBoleto([]);
        setLoadingParcelasAPagar(false);
      }
    else setLoadingParcelasAPagar(false);
  }

  useEffect(() => {
    if (contratoSelecionado.nome) parcelasAPagarFunction();
  }, [contratoSelecionado]);

  return (
    <>
      {solicitacaoInvalida && (
        <ErrorMsg setSolicitacaoInvalida={setSolicitacaoInvalida} />
      )}
      <HeaderStroke name={'Financeiro'} />

      <InfoMessage
        title={'Horário de funcionamento do financeiro'}
        message={
          <p>
            Geração de boletos, renegociação e pagamentos disponíveis das{' '}
            <b>08h00</b> às <b>23h50</b>
          </p>
        }
        tema={tema}
      />

      {gerarBoleto && (
        <GerarBoleto
          parcelasSelecionadas={parcelasSelecionadas}
          setParcelasSelecionadas={setParcelasSelecionadas}
          setGerarBoleto={setGerarBoleto}
          loading={loading}
          setLoading={setLoading}
          consultaDescontoAntecipacao={consultaDescontoAntecipacao}
          dadosDesconto={dadosDesconto}
          formataData={formataData}
          dataParaAgendar={dataParaAgendar}
          setDataParaAgendar={setDataParaAgendar}
          contratoSelecionado={contratoSelecionado}
          setParcelasAPagar={setParcelasAPagar}
          setParcelasAPagarComBoleto={setParcelasAPagarComBoleto}
          parcelasSelecionadasOriginal={parcelasSelecionadasOriginal}
          setParcelasSelecionadasOriginal={setParcelasSelecionadasOriginal}
          erroConsultarDescontoParcela={erroConsultarDescontoParcela}
          setErroConsultarDescontoParcela={setErroConsultarDescontoParcela}
          tema={tema}
          parcelasAPagar={parcelasAPagar}
        />
      )}
      {showModalGerarPix && (
        <ModalGerarPix
          parcelasSelecionadas={parcelasSelecionadas}
          tema={tema}
          setGerarPix={setShowModalGerarPix}
          contratoSelecionado={contratoSelecionado}
          parcelasAPagarFunction={parcelasAPagarFunction}
        />
      )}
      <Contratos
        setContrato={setContrato}
        setCodOcorrencia={setCodOcorrencia}
        idVenda={idVenda}
        tema={tema}
      />
      <Menu
        aPagar={parcelasAPagar}
        pagas={stateGetParcelasPagas}
        tema={tema}
        parcelasPagar={showParcelasPagar}
        setParcelasPagar={setshowParcelasPagar}
        parcelasPagas={showParcelasPagas}
        setParcelasPagas={setshowParcelasPagas}
        setGerarBoleto={setGerarBoleto}
        consultaDescontoAntecipacao={consultaDescontoAntecipacao}
        parcelasSelecionadas={parcelasSelecionadas}
        codOcorrencia={codOcorrencia}
        totalParcelasSelecionadas={parcelasSelecionadas?.length}
        temParcelasAPagar={parcelasAPagar?.length}
        setGerarExtrato={setGerarExtrato}
        setGerarIrrf={setGerarIrrf}
        setShowRenegociacao={setShowRenegociacao}
        gerarExtrato={gerarExtrato}
        gerarIrrf={gerarIrrf}
        codCobranca={codCobranca}
        disableMenuBtn={disableMenuBtn()}
        disableBtnIrrf={disableBtnIrrf}
        showRenegociacao={showRenegociacao}
        contratoSelecionado={contratoSelecionado}
        isWithinOperatingPaymentPeriod={isWithinOperatingPaymentPeriod}
      />
      {gerarExtrato && (
        <GerarExtrato
          contratoSelecionado={contratoSelecionado}
          codCobranca={codCobranca}
          setshowParcelasPagar={setshowParcelasPagar}
          setGerarExtrato={setGerarExtrato}
          setGerarIrrf={setGerarIrrf}
        />
      )}
      {gerarIrrf && (
        <GerarIrrf
          contratoSelecionado={contratoSelecionado}
          codCobranca={codCobranca}
          setshowParcelasPagar={setshowParcelasPagar}
          setGerarExtrato={setGerarExtrato}
          setGerarIrrf={setGerarIrrf}
        />
      )}
      {showParcelasPagar && (
        <ParcelasAPagar
          contratoSelecionado={contratoSelecionado}
          setGerarBoleto={setGerarBoleto}
          parcelasSelecionadas={parcelasSelecionadas}
          setParcelasSelecionadas={setParcelasSelecionadas}
          consultaDescontoAntecipacao={consultaDescontoAntecipacao}
          codOcorrencia={codOcorrencia}
          setParcelasAPagarComBoleto={setParcelasAPagarComBoleto}
          setParcelasAPagar={setParcelasAPagar}
          parcelasAPagar={parcelasAPagar}
          gerarBoleto={gerarBoleto}
          setSolicitacaoInvalida={setSolicitacaoInvalida}
          getParcelas={parcelasAPagarFunction}
          loading={loadingParcelasAPagar}
          gerarPix={showModalGerarPix}
          valoresAntecipacaoParcelas={valoresAntecipacaoParcelas}
          isWithinOperatingPaymentPeriod={isWithinOperatingPaymentPeriod}
          setshowParcelasPagas={setshowParcelasPagas}
          setshowParcelasPagar={setshowParcelasPagar}
        />
      )}
      {showParcelasPagas && (
        <ParcelasPagas
          parcelasPagas={stateGetParcelasPagas}
          loadingParcelasPagas={loadingParcelasAPagar}
          getParcelas={getParcelas}
        />
      )}
      {showRenegociacao && (
        <Renegociacao
          parcelasAPagar={parcelasAPagar}
          loadingParcelasAPagar={loadingParcelasAPagar}
          contratoSelecionado={contratoSelecionado}
          setshowParcelasPagar={setshowParcelasPagar}
          setShowRenegociacao={setShowRenegociacao}
          getParcelasAPagar={parcelasAPagarFunction}
        />
      )}

      {isWithinOperatingPaymentPeriod &&
        showParcelasPagar &&
        parcelasAPagar?.length > 0 &&
        dadosDocSign?.habilitarFinanceiro && (
          <ResumoBoletos
            tema={tema}
            parcelasAPagarComBoleto={parcelasAPagarComBoleto}
            loading={loading}
            setSolicitacaoInvalida={setSolicitacaoInvalida}
            contratoSelecionado={contratoSelecionado}
          />
        )}
    </>
  );
};

export default Financeiro;
